import { render, staticRenderFns } from "./setBlacklist.vue?vue&type=template&id=91e9ede8&scoped=true"
import script from "./setBlacklist.vue?vue&type=script&lang=js"
export * from "./setBlacklist.vue?vue&type=script&lang=js"
import style0 from "./setBlacklist.vue?vue&type=style&index=0&id=91e9ede8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e9ede8",
  null
  
)

export default component.exports